module.exports = __webpack_public_path__ + "5604a33c2be8ac1ea5f998ae03c21fd3.svg";